module.exports = __webpack_public_path__ + "img/rongYu3.64b5fbc8.png";